import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const { currentUser } = useSelector((state) => state.user);

    const navigate = useNavigate();

    const [showToolsMenu, setShowToolsMenu] = useState(false);
    const [showAuthDropdown, setShowAuthDropdown] = useState(false);

    const toolsDropdownRef = useRef(null);
    const authDropdownRef = useRef(null);

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (e) => {
        if (!toolsDropdownRef.current || !toolsDropdownRef.current.contains(e.target)) {
            setShowToolsMenu(false);
        }

        if (!authDropdownRef.current || !authDropdownRef.current.contains(e.target)) {
            setShowAuthDropdown(false);
        }
    };

    const handleToolsMenu = () => {
        setShowToolsMenu(!showToolsMenu);
        setShowAuthDropdown(false);
    };


    // const renderAuthButtons = () => {

    //     const handleAuthDropdown = () => {
    //         setShowAuthDropdown(!showAuthDropdown);
    //         setShowToolsMenu(false);
    //     };

    //     if (currentUser) {
    //         return (
    //             <div
    //                 className="relative group"
    //                 onClick={handleAuthDropdown}
    //                 ref={authDropdownRef}
    //             >
    //                 <Link to="/profile" className="text-white">
    //                     <div className="inline-block relative">
    //                         <div className="bg-gray-600 rounded-full h-8 w-8 flex items-center justify-center">
    //                             <span className="text-sm">P</span>
    //                         </div>
    //                         {showAuthDropdown && (
    //                             <div className="hidden md:block absolute top-0 right-0 mt-10 bg-white p-2 rounded-md shadow-lg w-[8rem]">
    //                                 <Link
    //                                     to="/your-files"
    //                                     className="block px-4 py-2 text-gray-800 hover:bg-gray-200 hover:text-black"
    //                                 >
    //                                     Your Files
    //                                 </Link>
    //                                 <Link
    //                                     to="/sign-out"
    //                                     className="block px-4 py-2 text-gray-800 hover:bg-gray-200 hover:text-black"
    //                                 >
    //                                     Sign Out
    //                                 </Link>
    //                             </div>
    //                         )}
    //                     </div>
    //                 </Link>
    //             </div>
    //         );
    //     } else {
    //         return (
    //             <Link to="/sign-in" className="text-white hover:bg-gray-800 px-4 py-2 rounded-md">
    //                 Sign In
    //             </Link>
    //         );
    //     }
    // };



    return (
        <nav className="bg-gray-800 p-4 relative z-50 w-full">
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-white text-xl font-bold">jacketrafa</div>
                
                <div className="hidden md:flex space-x-4 items-center">
                    <Link to="/" className="text-white hover:bg-gray-700 px-4 py-2 rounded-md">
                        Home
                    </Link>
                    <div
                        className="relative group"
                        onClick={handleToolsMenu}
                        ref={toolsDropdownRef}
                    >
                        <span className="cursor-pointer text-white hover:bg-gray-700 px-4 py-2 rounded-md">
                            Tools
                            <span className="ml-1">&#9662;</span>
                        </span>
                        {showToolsMenu && (
                            <div className="absolute top-0 right-0 mt-10 bg-white p-2 rounded-md shadow-lg z-10">
                                <Link to="/audio-transcribe" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                                    Upload & Transcribe
                                </Link>
                                <Link to="/voice-transcribe" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                                    Record & Transcribe
                                </Link>
                                <Link to="/translate" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                                    Translation
                                </Link>
                                <Link to="/pdf-to-text" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                                    Pdf to Text
                                </Link>
                            </div>
                        )}
                    </div>
                    <Link to="/faqs" className="text-white hover:bg-gray-700 px-4 py-2 rounded-md">
                        FAQs
                    </Link>
                    <Link to="/contact" className="text-white hover:bg-gray-700 px-4 py-2 rounded-md">
                        Contact
                    </Link>
                    <Link to={"/profile"}>
                        {currentUser ? (
                            <img src={currentUser.avatar} alt="profile" className="rounded-full h-7 w-7 object-cover" />
                        ) : (
                            <Link to="/sign-in" className="text-white hover:bg-gray-800 px-4 py-2 rounded-md">
                                Sign In
                            </Link>
                        )}
                    </Link>
                </div>

                <div className="md:hidden">
                    <button
                        onClick={handleToolsMenu}
                        className="text-white focus:outline-none focus:border-none"
                    >
                        ☰
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
